const libraries = [
  "OpenCV",
  "Ultralytics YOLO (YOLOv8/YOLOv11)",
  "NumPy",
  "Pandas",
  "Scikit-learn",
  "MongoDB (NoSQL)",
  "MySQL",
  "Oracle SQL",
  "OpenAI API",
  "PySpark"
];

export default libraries;